import React from "react";
import Layout from "../components/Layout";
import { SEO } from "../components/SEO";
import ContactForm from "../components/ContactForm";
import { PageOuter } from "../components/PageOuter";
import ScrollToTop from "../components/ScrollToTop";

const ContactPage = (): JSX.Element => {
  const title = "Contact";
  return (
    <Layout
    // location={props.location} /
    >
      <SEO title={`Blue Beck - ${title}`} />
      <ScrollToTop showBelow={100} />
      <PageOuter title={title}>
        <ContactForm />
      </PageOuter>
    </Layout>
  );
};

export default ContactPage;
